export default "__VITE_ASSET__gTl9WEsk__"